export default __webpack_public_path__ + "static/media/Screenshot_9.a2a0d16e.png";